<template lang="pug">
.log-wrapper
  .text-center.mb-4
    .row.justify-content-center
      .col-md-6
        img(:src="path")
</template>

<script>
export default {
  components: {
  },
  data: function() {
    return {
      loading: false,
      submission: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
    path() {
      return this.$store.getters.attachmentPath;
    }
  },
};
</script>

